export const groupsList = [
    { id: 0, title: 'Организации', checked: true, code: 'organization' },
    { id: 1, title: 'Месторождения', checked: false, code: 'field' },
    { id: 2, title: 'Площади', checked: false, code: 'area' },
    { id: 3, title: 'Разведочные площади', checked: false, code: 'exploration_area' },
    { id: 4, title: 'Исследования', checked: false, code: 'research' },
    { id: 5, title: 'Исследования керна', checked: false, code: 'core' },
    { id: 6, title: 'Опробование скважин', checked: false, code: 'testing' },
    { id: 7, title: 'Лицензионные участки', checked: false, code: 'license' },
    { id: 8, title: 'Структурно-параметрические скважины', checked: false, code: 'groupStructureWell' },
    { id: 9, title: 'Неглубокие скважины', checked: false, code: 'itemNotDeepWell' },
    { id: 10, title: 'Профайлы', checked: false, code: 'profile' },
];

const defaultList = [
    { label: 'С объектами / элементами разработки', value: 'develop' }, // TODO: переписать на бекенд.
    { label: 'С площадями', value: 'area' },
    { label: 'С куполами, поднятиями', value: 'elevation' },
    { label: 'Со структурно-параметрическими', value: 'groupStructureWell' },
    { label: 'С неглубокими скважинами', value: 'itemNotDeepWell' },
    { label: 'С лицензионными участками', value: 'license' },
];

// ARM-3788
// FIXME: переписать на бекенд.
// В связи с тем, что на текущий момент на бэкенде нету связи режимов дерева и
// его категорий, по согласованию с бэкендом на данный момент используется данный конфиг

// Бывший modesList => treeLevels
export const treeLevels = {
    profile: [
        { label: 'С площадями', value: 'area' },
        { label: 'С куполами, поднятиями', value: 'elevation' },
    ],
    organization: defaultList,
    field: defaultList,
    area: defaultList.filter(item => item.value !== 'area'),
    exploration_area: defaultList,
    research: [],
    core: [],
    testing: [],
    license: defaultList.filter(item =>  !['develop', 'license'].includes(item.value)),
    groupStructureWell: [],
    itemNotDeepWell: [],
};
